import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import * as React from "react";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { AiFillCaretRight } from "react-icons/ai";
import { BiMenuAltLeft, BiMenuAltRight } from "react-icons/bi";
import { IoCaretForwardCircleSharp } from "react-icons/io5";
import { useMediaQuery } from "react-responsive";
import { Link, NavLink } from "react-router-dom";
import "./mobilenav.scss";

import SearchModal from "./searchModal";

export default function TemporaryDrawer() {
	const [state, setState] = useState(false);
	const [searchPopOverOpen, setSearchPopOverOpen] = useState(false);
	const scrolled = false;

	const [serviceDropDown, setServiceDropDown] = useState(false);
	const [serviceLabDropDown, setServiceLabDropDown] = useState(false);
	const [serviceEduDropDown, setServiceEduDropDown] = useState(false);

	const [aboutUsDropDown, setAboutUsDropDown] = useState(false);

	const isMobile = useMediaQuery({ query: "(max-width: 500px)" });
	const toggleDrawer = () => {
		setState(!state);
	};

	const List2 = () => {
		return (
			<>
				<Box sx={{ width: isMobile ? "300px" : "400px" }} role="presentation">
					<List className="LIStWrapper">
						<div className="MobileContainer">
							<Link className="navbar-brand" to="/">
								<img
									alt="logo"
									className="logo"
									src={"https://res.cloudinary.com/ggi/image/upload/v1637903431/logo_ku2fnp.webp"}
								/>
								<h2 className="Heading">GGI</h2>
							</Link>
							<Button onClick={() => toggleDrawer()} className="CloseIcon">
								<BiMenuAltRight />
							</Button>
						</div>
						<div className="navContact ScrollSearch searchButtonMob">
							<Button
								onClick={() => {
									setSearchPopOverOpen(true);
									toggleDrawer()
								}}
								className="SearchButton nav-link"
							>
								Verify Your Report
							</Button>

						</div>
						<li className="nav-item">
							<NavLink
								onClick={() => toggleDrawer()}
								exact
								activeClassName="active"
								to="/"
								className="nav-link"
								aria-current="page"
							>
								HOME
							</NavLink>
						</li>

						<li className="nav-item dropdown ">
							<div className="nav-link" onClick={() => setServiceDropDown(!serviceDropDown)}>
								{/* <NavLink
								exact
								activeClassName="active"
								to="#"
								className="nav-link"
								id=""
								role=""
								data-bs-toggle="dropdown"
								aria-expanded="false"
							> */}
								SERVICES
								<AiFillCaretRight className="NavbarCaret" />
							</div>
							{/* </NavLink> */}
							<ul className="dropdown-menu drodpDownNav" style={serviceDropDown ? { display: 'block' } : { display: 'none' }} aria-labelledby="navbarDropdown">
								<li className="nav-item Subdropdown">
									<div className="Subnav-link SubMenuParent" onClick={() => setServiceLabDropDown(!serviceLabDropDown)}>
										{/* <NavLink
								// onClick={() => toggleDrawer()}
								exact
								activeClassName="active"
								to="#"
								className=""
								id=""
								role=""
								data-bs-toggle="dropdow"
								aria-expanded="false"
							> */}
										LABORATORY
										<IoCaretForwardCircleSharp className="SubNavCaret" />
									</div>
									{/* </NavLink> */}
									<ul className="Subdropdown-menu SubdrodpDownNav" style={serviceLabDropDown ? { display: 'block' } : { display: 'none' }} aria-labelledby="navbarDropdown">
										<li>
											<NavLink
												onClick={() => toggleDrawer()}
												exact
												activeClassName="active"
												to="/laboratory/about-ggi-laboratory"
											>
												About GGI Laboratory
											</NavLink>
										</li>
										<li>
											<NavLink
												onClick={() => toggleDrawer()}
												exact
												activeClassName="active"
												to="/laboratory/lab-reports"
											>
												Lab Reports
											</NavLink>
										</li>
										<li>
											<NavLink
												onClick={() => toggleDrawer()}
												exact
												activeClassName="active"
												to="/laboratory/lab-service-fee"
											>
												Lab Service Fee
											</NavLink>
										</li>
										<li>
											<NavLink
												onClick={() => toggleDrawer()}
												exact
												activeClassName="active"
												to="/laboratory/terms-and-conditions"
											>
												Terms And Conditions
											</NavLink>
										</li>
									</ul>
								</li>
								<li className="nav-item Subdropdown">
									{/* <NavLink
										exact
										activeClassName="activeAbout"
										// to="/gemological-education"
										
										id=""
										role=""
										data-bs-toggle="dropdow"
										aria-expanded="false"
									> */}
									<div className="Subnav-link SubMenuParent" onClick={() => setServiceEduDropDown(!serviceEduDropDown)}>
										EDUCATION
										<IoCaretForwardCircleSharp className="SubNavCaret" />
									</div>
									{/* </NavLink> */}
									<ul className="Subdropdown-menu SubdrodpDownNav" style={serviceEduDropDown ? { display: 'block' } : { display: 'none' }} aria-labelledby="navbarDropdown">
										<li>
											<NavLink
												onClick={() => toggleDrawer()}
												exact
												activeClassName="activeAbout"
												to="/gemological-education"
											>
												Gemological Education
											</NavLink>
										</li>
										<li>
											<NavLink
												onClick={() => toggleDrawer()}
												exact
												activeClassName="activeAbout"
												to="/gemological-education/schedule"
											>
												Course Schedule
											</NavLink>
										</li>
										<li>
											<NavLink
												onClick={() => toggleDrawer()}
												exact
												activeClassName="active"
												to="/gemological-education/courses"
											>
												Courses
											</NavLink>
										</li>
									</ul>
								</li>

								<li>
									<NavLink
										onClick={() => toggleDrawer()}
										exact
										activeClassName="active"
										to="/appraisal"
									>
										Appraisal
									</NavLink>
								</li>
								<li>
									<NavLink
										onClick={() => toggleDrawer()}
										exact
										activeClassName="active"
										to="/gemology"
									>
										Gemology
									</NavLink>
								</li>
								<li>
									<NavLink
										onClick={() => toggleDrawer()}
										exact
										activeClassName="active"
										to="/gemology/YourBirthStone"
									>
										Find Your Birth Stone
									</NavLink>
								</li>
							</ul>
						</li>

						<li className="nav-item dropdown">
							{/* <NavLink
								// onClick={() => toggleDrawer()}
								exact
								activeClassName="activeAbout"
								to="/about"
								className="nav-link AboutLi"
								id=""
								role=""
								data-bs-toggle="dropdow"
								aria-expanded="false"
							> */}
							<div className="nav-link" onClick={() => setAboutUsDropDown(!aboutUsDropDown)}>
								ABOUT US
								<AiFillCaretRight className="NavbarCaret" />
							</div>
							{/* </NavLink> */}
							<ul className="dropdown-menu drodpDownNav AboutDrop" style={aboutUsDropDown ? { display: 'block' } : { display: 'none' }} aria-labelledby="navbarDropdown">
								<li>
									<NavLink
										onClick={() => toggleDrawer()}
										exact
										className="AboutSubLi"
										activeClassName="activeAbout"
										to="/about"
									>
										Company
									</NavLink>
								</li>
								<li>
									<NavLink
										onClick={() => toggleDrawer()}
										exact
										activeClassName="activeAbout"
										className="AboutSubLi"
										to="/about/found-and-ceo"
									>
										Founder And CEO
									</NavLink>
								</li>
							</ul>
						</li>

						<li className="nav-item">
							<NavLink
								onClick={() => toggleDrawer()}
								exact
								activeClassName="active"
								to="/contact-us"
								className="nav-link"
								tabindex="-1"
							>
								CONTACT US
							</NavLink>
						</li>
					</List>
				</Box>

			</>
		);
	};

	return (
		<>
			<div className="mobNav">
				<nav className="navbar navbar-expand-lg navbar-light bg-light">
					<div className="container-fluid">
						<Link className="navbar-brand" to="/">
							<img
								alt="logo"
								className="logo"
								src={"https://res.cloudinary.com/ggi/image/upload/v1637903431/logo_ku2fnp.webp"}
							/>
							<h2 className="Heading">GGI</h2>
						</Link>
						<Button onClick={() => toggleDrawer()} className="CloseIcon">
							<BiMenuAltLeft />
						</Button>
					</div>
				</nav>
				<Drawer open={state} onClose={() => toggleDrawer()}>
					<List2 />
				</Drawer>
			</div>
			<Modal
				size="sm"
				dialogClassName="Model"
				style={{ top: scrolled ? "5%" : "15%" }}
				show={searchPopOverOpen}
				onHide={() => setSearchPopOverOpen(false)}
				aria-labelledby="example-modal-sizes-title-sm"
			>
				<Modal.Body>
					<SearchModal />
				</Modal.Body>
			</Modal>
		</>
	);
}
